"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RETIRED_DOWNPAYMENT_TRIGGERS = exports.DOWNPAYMENT_TRIGGER_LABELS = exports.PAYMENT_TRIGGER_EVENT_ORDER = exports.PAYMENT_TRIGGER_EVENT_LABELS = void 0;
exports.paymentTriggerEventLabel = paymentTriggerEventLabel;
exports.comparePaymentTriggerEvents = comparePaymentTriggerEvents;
exports.formatPaymentTrigger = formatPaymentTrigger;
exports.downpaymentTriggerLabel = downpaymentTriggerLabel;
// Maps the Prisma TS-safe enum identifier back to the DB / display string
// (the @map value from `payment_trigger_event_enum` in schema.prisma).
exports.PAYMENT_TRIGGER_EVENT_LABELS = {
    Advance_with_Proforma: 'Advance with Proforma',
    ATA_at_Final_destination: 'ATA at Final destination',
    BL_confirmed: 'BL confirmed',
    BL_issuance: 'BL issuance',
    BL_release: 'BL release',
    Booking: 'Booking',
    Customs_Clearance: 'Customs Clearance',
    DP: 'DP',
    ETA_at_Final_destination: 'ETA at Final destination',
    ETD: 'ETD',
    Fixation: 'Fixation',
    Inspection: 'Inspection',
    Invoice: 'Invoice',
    Loading: 'Loading',
    Order_Signed_Date: 'Order Signed Date',
    ATA_at_PoD: 'ATA at PoD',
    ETA_at_PoD: 'ETA at PoD',
    ATA_at_Customer_Site: 'ATA at Customer Site',
    Sorting_at_buyer_s_factory: "Sorting at buyer's factory",
};
function paymentTriggerEventLabel(event) {
    if (event === null)
        return null;
    return exports.PAYMENT_TRIGGER_EVENT_LABELS[event] ?? event;
}
// Trigger events follow the deal → delivery lifecycle so the dropdown reads
// in the order a transaction actually moves, rather than the enum's
// alphabetical default. First pass open to ops refinement; unlisted events
// sort to the end.
exports.PAYMENT_TRIGGER_EVENT_ORDER = [
    'Advance_with_Proforma',
    'Order_Signed_Date',
    'Fixation',
    'DP',
    'Booking',
    'Loading',
    'ETD',
    'BL_issuance',
    'BL_confirmed',
    'BL_release',
    'Invoice',
    'ETA_at_PoD',
    'ATA_at_PoD',
    'Customs_Clearance',
    'Inspection',
    'ETA_at_Final_destination',
    'ATA_at_Final_destination',
    'ATA_at_Customer_Site',
    'Sorting_at_buyer_s_factory',
];
function comparePaymentTriggerEvents(a, b) {
    const rank = (e) => {
        const i = exports.PAYMENT_TRIGGER_EVENT_ORDER.indexOf(e);
        return i === -1 ? exports.PAYMENT_TRIGGER_EVENT_ORDER.length : i;
    };
    const diff = rank(a) - rank(b);
    return diff !== 0 ? diff : a.localeCompare(b);
}
function formatPaymentTrigger(trigger) {
    if (trigger?.event == null)
        return '—';
    const offset = trigger.offsetDays === null ? null : Number(trigger.offsetDays);
    if (offset !== null && !Number.isNaN(offset) && offset !== 0) {
        const timing = trigger.timing ?? 'After';
        return `${String(Math.abs(offset))} days ${timing} ${trigger.event}`;
    }
    if (trigger.timing !== null) {
        return `${trigger.timing} ${trigger.event}`;
    }
    return `On ${trigger.event}`;
}
// Advance-downpayment trigger labels (launchpad parity, QA #463; Fence vocabulary
// #1921). Maps the Prisma enum identifier back to its display string. Since #1921
// the downpayment vocabulary carries Fence's full trigger set, so most keys here
// coincide with PAYMENT_TRIGGER_EVENT_LABELS; the map is kept separate because the
// two enums are distinct DB types and the downpayment leg keeps its own extras
// (Advance_with_Proforma, and the retired duplicates below, for display).
exports.DOWNPAYMENT_TRIGGER_LABELS = {
    Advance_with_Proforma: 'Advance with Proforma',
    Against_Loading: 'Against Loading',
    Against_Released_BL: 'Against Released BL',
    ATA: 'ATA',
    Booking: 'Booking',
    ETA: 'ETA',
    Invoice: 'Invoice',
    Loading: 'Loading',
    Order_Signed_Date: 'Order Signed Date',
    ETD: 'ETD',
    Inspection: 'Inspection',
    Fixation: 'Fixation',
    BL_issuance: 'BL issuance',
    BL_confirmed: 'BL confirmed',
    BL_release: 'BL release',
    Customs_Clearance: 'Customs Clearance',
    DP: 'DP',
    ETA_at_PoD: 'ETA at PoD',
    ATA_at_PoD: 'ATA at PoD',
    ETA_at_Final_destination: 'ETA at Final destination',
    ATA_at_Final_destination: 'ATA at Final destination',
    ATA_at_Customer_Site: 'ATA at Customer Site',
    Sorting_at_buyer_s_factory: "Sorting at buyer's factory",
};
// Retired downpayment triggers (Fizzy #1921). Two are collapsed onto their Fence
// equivalents (`Against_Loading` → `Loading`, `Against_Released_BL` → `BL_release`).
// The bare `ATA` / `ETA` are retired outright: the granular arrival events
// (`ETA_at_PoD` / `ATA_at_PoD` / `ETA_at_Final_destination` / `ATA_at_Final_destination`)
// already cover them, so the ambiguous bare pair is dropped (Peeyush, 2026-08-31;
// 0 prod rows, no migration). Postgres cannot drop an enum member, so withholding
// them from the served vocabulary + the write path + the Fence contract values IS
// the deprecation. Their labels stay in DOWNPAYMENT_TRIGGER_LABELS so any lingering
// stored value still renders. This is the single source of the retired set,
// consumed across the served-vocabulary surfaces (reference-enums, eligibility rule
// authoring, the data-tape Fence contract values) and the ticket write guard.
exports.RETIRED_DOWNPAYMENT_TRIGGERS = [
    'Against_Loading',
    'Against_Released_BL',
    'ATA',
    'ETA',
];
function downpaymentTriggerLabel(trigger) {
    if (trigger === null)
        return null;
    return exports.DOWNPAYMENT_TRIGGER_LABELS[trigger] ?? trigger;
}
//# sourceMappingURL=payment-trigger.js.map